import { useAppScrollRef } from '@doltech/core/lib/appScroll/withAppScroll';
import { BLOG_SECTION_PREFIX } from '@doltech/utils/lib/url';
import { SelectProps, Space } from 'antd';
import { get } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Editor } from 'slate';

import { Typography } from '../../../../DesignSystemV2/Typography';
import { useDolEditorStore } from '../../../../DolEditor/dol-editor.store';
import { DolSelectComponent } from '../../../../Select/DolSelect';
import { DEFAULTS_OPTIONS } from '../../../editorDefaultOptions';

export interface AnchorPickerProps extends SelectProps<string> {}

const getAnchorPickerFromEditor = (editor) => {
  if (editor) {
    const arr = [];
    const nodeEntries: any = Editor.nodes(editor, {
      at: [],
    });
    for (const [node, path] of nodeEntries) {
      if (path.length === 1 && node?.type === DEFAULTS_OPTIONS.h2.type) {
        arr.push({
          value: `${BLOG_SECTION_PREFIX}${arr.length + 1}`,
          label: get(node, 'children[0].text'),
        });
      }
    }

    return arr;
  }

  return [];
};

export const AnchorPicker = observer((props: AnchorPickerProps) => {
  const editorStore = useDolEditorStore();
  const [options, setOptions] = React.useState<any>();
  const { appContainerRef } = useAppScrollRef();

  React.useEffect(() => {
    setOptions(getAnchorPickerFromEditor(editorStore.editor));
  }, [editorStore.editor]);

  return (
    <Space direction="vertical" size={2}>
      <Typography.Text variant="medium/12" color="black60">
        Gắn neo
      </Typography.Text>
      <DolSelectComponent
        onDropdownVisibleChange={(open) => {
          if (open) {
            setOptions(getAnchorPickerFromEditor(editorStore.editor));
          }
        }}
        getPopupContainer={() => appContainerRef.current}
        placeholder="Dropdown Option"
        filterOption
        optionFilterProp="label"
        options={options}
        showSearch
        {...props}
      />
    </Space>
  );
});
